/* eslint-disable react/prop-types */
import React from 'react';
import ReactPlayerVideo from './react-player-video';

interface YouTubeVideoProps {
    videoId: string;
    title: string;
    onError: (error: unknown) => void;
}

const YouTubeVideo: React.FC<YouTubeVideoProps> = ({
    videoId,
    title,
    onError
}) => {
    if (!videoId) {
        onError('YouTube video ID is empty');
        return null;
    }

    return (
        <ReactPlayerVideo
            url={`https://www.youtube.com/watch?v=${encodeURIComponent(
                videoId
            )}`}
            title={title}
            onError={onError}
        />
    );
};

export default YouTubeVideo;
